import React, { useEffect, useRef } from 'react'

export const ImageContainer = ({ url, onLoad, className="", ...rest }) => {
  const bgRef = useRef();

  useEffect(()=>{
    (async ()=>{
      await new Promise((resolve)=>{
        const img = new Image();
        img.src = url;
        img.onload = resolve;
      });
      
      bgRef.current.style.backgroundImage = `url("${url}")`;
      onLoad?.();
    })();
  },[]);

  return (
    <div
      className={`
        w-full h-[50vh] lg:h-[60vh] bg-center bg-cover scale-105 
        ${className}
      `}
      ref={bgRef}
      { ...rest }
    />
  )
}
